import {
  LayoutDashboard,
  CalendarCheck,
  CalendarRange,
  ArrowLeftRight,
  Tags,
  Tag,
  CalendarDays,
  Ticket,
  Building2,
  Hotel,
  Percent,
  Mail,
  FileText,
  FileSignature,
  Users,
  Settings,
  SlidersHorizontal,
  SquareParking,
  Car,
  Wrench,
  Timer,
  CreditCard,
  IdCard,
  Plug,
  ScrollText,
  UserCog,
  ShieldCheck,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  label: string
  to: string
  model?: string // Yep content model id (for the list view)
  icon?: LucideIcon
}
export interface NavGroup {
  label: string
  icon: LucideIcon
  items: NavItem[]
}
export interface NavLabel {
  sectionLabel: string
}
export type NavEntry = NavItem | NavGroup | NavLabel

export function isGroup(e: NavEntry): e is NavGroup {
  return (e as NavGroup).items !== undefined
}
export function isLabel(e: NavEntry): e is NavLabel {
  return (e as NavLabel).sectionLabel !== undefined
}

// Order + grouping mirror the design mockup (gsm-admin-design.html).
export const NAV: NavEntry[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboard },
  { label: 'Prenotazioni', to: '/reservations', model: 'reservation', icon: CalendarCheck },
  { label: 'Utenti registrati', to: '/members', model: 'member', icon: Users },

  { sectionLabel: 'Operatività' },
  {
    label: 'Disponibilità',
    icon: CalendarRange,
    items: [
      { label: 'Disponibilità', to: '/availability', model: 'availability', icon: SquareParking },
      { label: 'In & Out', to: '/in-out', model: 'inOut', icon: ArrowLeftRight },
    ],
  },
  {
    label: 'Tariffe',
    icon: Tags,
    items: [
      { label: 'Gestione tariffe', to: '/rates', model: 'rate', icon: Tag },
      { label: 'Calendario tariffe', to: '/rate-calendar', model: 'rateCalendar', icon: CalendarDays },
      { label: 'Coupon', to: '/coupons', model: 'coupon', icon: Ticket },
    ],
  },
  {
    label: 'Convenzioni',
    icon: Building2,
    items: [
      { label: 'Hotel convenzionati', to: '/conventions', model: 'convention', icon: Hotel },
      { label: 'Scontistica', to: '/convention-config', model: 'conventionConfiguration', icon: Percent },
    ],
  },
  {
    label: 'Contenuti',
    icon: FileText,
    items: [
      { label: 'Email', to: '/emails', model: 'email', icon: Mail },
      { label: 'Contratti', to: '/contracts', model: 'pdf', icon: FileSignature },
    ],
  },

  { sectionLabel: 'Sistema' },
  {
    label: 'Configurazione',
    icon: Settings,
    items: [
      { label: 'Generale', to: '/config/general', model: 'generalConfiguration', icon: SlidersHorizontal },
      { label: 'Tipi di veicolo', to: '/config/transports', model: 'transport', icon: Car },
      { label: 'Servizi', to: '/config/services', model: 'service', icon: Wrench },
      { label: 'Opzioni durata sosta', to: '/config/durations', model: 'duration', icon: Timer },
      { label: 'Metodi di pagamento', to: '/config/payment-modes', model: 'paymentMode', icon: CreditCard },
      { label: 'Card Parking', to: '/config/pcard', model: 'pcardConfiguration', icon: IdCard },
      { label: 'Terze parti', to: '/config/third-party', model: 'thirdPartyConfiguration', icon: Plug },
      { label: 'Log', to: '/config/log', model: 'gsmLog', icon: ScrollText },
    ],
  },
  {
    label: 'Accessi',
    icon: ShieldCheck,
    items: [
      { label: 'Operatori', to: '/users', icon: UserCog },
      { label: 'Gruppi e permessi', to: '/groups', icon: ShieldCheck },
    ],
  },
]
